<template>
    <img
      class="logo"
      :src="`${imgUrl}/${newspaper}`"
    />
    <!-- <img
      class="logo"
      :src="`../../../public/img/logo/${newspaper}`"
    /> -->
    <!-- <img
      v-else
      class="logo"
      :src="imgJpgPath"
    /> -->
</template>

<script>
import { useRoute } from 'vue-router'
export default {
  name: 'Logo',
  setup () {
    const route = useRoute()
    const newspaper = route.params.accessName + '_logo.jpg'
    const imgUrl = process.env.VUE_APP_LOGO_URL
    return {
      newspaper,
      imgUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.logo{
  flex: 1;
  width: 130px;
  margin-left: 4px;
}
</style>
